<template>
  <el-table
    v-loading="loading"
    :data="data"
    size="medium"
    border
    stripe
  >
    <el-table-column
      label="STT"
      width="80"
      fixed="left"
      align="center"
    >
      <template slot-scope="scope">
        <span>
          {{ scope.row.stt }}
        </span>
      </template>
    </el-table-column>
    <el-table-column
      v-for="field in fields"
      :key="field.key"
      :prop="field.key"
      :label="field.label"
    >
      <template slot-scope="scope">
        <span v-if="[fieldType.DATE, fieldType.DATETIME].includes(field.type)">
          {{ scope.row.extra[field.key] | convertDateTime(field.format) }}
        </span>
        <span v-else>
          {{ scope.row.extra[field.key] }}
        </span>
      </template>
    </el-table-column>
    <el-table-column
      v-for="object in categoryObjects"
      :key="object.extra.key"
      :prop="object.extra.key"
      :label="object.extra.name"
      align="center"
    >
      <template slot-scope="scope">
        <span>
          {{ scope.row.id | objectCountValue(object.extra.key, objectCounts) }}
        </span>
      </template>
    </el-table-column>
    <el-table-column
      label="Thao tác"
      width="200"
      fixed="right"
      align="center"
    >
      <template slot-scope="scope">
        <el-row
          type="flex"
          justify="center"
        >
          <el-tooltip
            v-if="permission.UPDATE"
            content="Sửa dữ liệu"
            effect="dark"
            placement="top"
          >
            <el-button
              icon="el-icon-edit"
              type="primary"
              size="medium"
              circle
              @click="() => $emit('update', scope.row)"
            />
          </el-tooltip>
          <el-tooltip
            v-if="permission.DELETE"
            content="Xoá trường dữ liệu"
            effect="dark"
            placement="top"
          >
            <el-button
              icon="el-icon-delete"
              type="danger"
              size="medium"
              circle
              @click="() => $emit('delete', scope.row)"
            />
          </el-tooltip>
        </el-row>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import constants from "@/config/constants";

export default {
  name: "CardList",
  components: {},
  props: {
    fields: Array,
    data: Array,
    loading: Boolean,
    permission: Object,
    categoryObjects: Array,
    objectCounts: Array
  },
  data() {
    return {
      fieldType: constants.FIELD_TYPE,
    };
  },
  computed: {
    columnFields() {
      return (this.fields || []).filter((f) => f.show.column);
    },
  },
  methods: {},
};
</script>

<style lang="scss"></style>
